import { z } from "zod";

export const FaaAirmanRatingSchema = z.object({
	level: z.string(),
	rating: z.string(),
});

export type FaaAirmanRating = z.infer<typeof FaaAirmanRatingSchema>;
